import { withFieldGroup } from "..";
import { Column, Input, Row } from "@gradience/ui";

type AddressFieldGroupValues = {
  line1: string;
  line2: string | undefined;
  city: string;
  state: string;
  zip: string;
};
const defaultValues: AddressFieldGroupValues = {
  line1: "",
  line2: undefined,
  city: "",
  state: "",
  zip: "",
};

export const AddressFieldGroup = withFieldGroup({
  defaultValues,
  render: function Render({ group }) {
    return (
      <Column gap={8}>
        <group.AppField name="line1">
          {(field) => (
            <field.TextField
              placeholder="Street Address 1"
              label="School Address"
              required
            />
          )}
        </group.AppField>
        <group.AppField name="line2">
          {(field) => <field.TextField placeholder="Street Address 2" />}
        </group.AppField>
        <Row gap={8}>
          <group.AppField name="city">
            {(field) => <field.TextField placeholder="City" />}
          </group.AppField>
          <Row gap={8} style={{ flex: 1 }}>
            <group.AppField name="state">
              {(field) => <field.TextField placeholder="State" />}
            </group.AppField>
            <group.AppField name="zip">
              {(field) => <field.TextField placeholder="Zip" />}
            </group.AppField>
          </Row>
        </Row>
      </Column>
    );
  },
});
